import React from 'react';
import { LinkButton } from './Button';
import { UserName } from '../containers/UserName';
import { UserId } from '../containers/UserId';
import { PageContainer, Input, H1, ButtonSet, Container } from './Layout';
import { useLocation } from 'react-router-dom';
import { createUser } from '../hooks/api';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

export const Login: React.FC = () => {
    const { userName, setUserName } = UserName.useContainer();
    const { userId } = UserId.useContainer();
    const query = useQuery();
    const redirect = query.get('redirect') || '/join';

    return !!userId ? (
        <PageContainer>
            <Container>
                <H1>Enter Your Name</H1>
                <Input
                    placeholder="Your name"
                    value={userName}
                    onChange={(e) => setUserName(e.target.value.replace(/[^0-9a-z]/gi, ''))}
                    type="text"
                />
                <ButtonSet>
                    <LinkButton disabled={!userName} to={redirect}>
                        Login
                    </LinkButton>
                </ButtonSet>
            </Container>
        </PageContainer>
    ) : null;
};

